import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContainerComponent } from './components/container/container.component';
import { canActivate, canActivateChild } from '../shared/guards/auth.guard';
const routes: Routes = [
  {
    path: '',
    component: ContainerComponent,
    canActivate: [canActivate],
    canActivateChild: [canActivateChild],
    loadChildren: () =>
      import('./../modules/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'vehicles',
    component: ContainerComponent,
    canActivate: [canActivate],
    canActivateChild: [canActivateChild],
    loadChildren: () =>
      import('./../modules/vehicles/vehicles.module').then(
        (m) => m.VehiclesModule,
      ),
  },
  {
    path: 'offers',
    component: ContainerComponent,
    canActivate: [canActivate],
    canActivateChild: [canActivateChild],
    loadChildren: () =>
      import('./../modules/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./../modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: '**',
    component: ContainerComponent,
    loadChildren: () =>
      import('./../modules/nopage/nopage.module').then((m) => m.NoPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class CoreRoutingModule {}
